import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  query,
  orderBy,
  onSnapshot,
  doc,
  getDoc,
  updateDoc
} from "firebase/firestore";
import { Box, TextField, Button, Typography } from "@mui/material";
import { isLoggedIn } from "../session";
import BottomNav from "./BottomNav";
import Header3 from "./Header3";

function ChatBox() {
  const { productId, sellerId } = useParams();
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [authUserId, setAuthUserId] = useState(null);
  const [authUserDisplayName, setAuthUserDisplayName] = useState("");
  const messagesEndRef = useRef(null);

  useEffect(() => {
    const fetchAuthUserId = async () => {
      const user = await isLoggedIn();
      if (user) {
        const userId = user.uid;
        setAuthUserId(userId);
        console.log("UserID:", userId);

        const userDocRef = doc(db, "users", userId);
        const userDocSnapshot = await getDoc(userDocRef);
        if (userDocSnapshot.exists()) {
          setAuthUserDisplayName(userDocSnapshot.data().displayName);
        }

        const collectionPath = `products/${productId}/messages`;
        const messagesRef = collection(db, collectionPath);

        const q = query(messagesRef, orderBy("timestamp"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
          const messages = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setMessages(messages);
          // Scroll to bottom when new messages are loaded
          messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
        });

        return () => unsubscribe();
      }
    };
    fetchAuthUserId();
  }, [productId]);

  const handleSendMessage = async () => {
    if (newMessage.trim() === "" || !authUserId) return;

    const message = {
      content: newMessage,
      timestamp: new Date(),
      senderId: authUserId,
      receiverId: sellerId,
      senderDisplayName: authUserDisplayName,
      read: false,
    };

    const collectionPath = `products/${productId}/messages`;
    const messagesRef = collection(db, collectionPath);

    try {
      await addDoc(messagesRef, message);
      setNewMessage("");
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    } catch (error) {
      console.error("Error sending message: ", error);
    }
  };

  const markMessageAsRead = async (messageId) => {
    const messageRef = doc(db, `products/${productId}/messages`, messageId);
    try {
      await updateDoc(messageRef, { read: true });
    } catch (error) {
      console.error("Error marking message as read: ", error);
    }
  };

  useEffect(() => {
    messages.forEach((message) => {
      if (message.receiverId === authUserId && !message.read) {
        markMessageAsRead(message.id);
      }
    });
  },);

  return (
    <Box sx={{ backgroundColor: "slateblue" }}>
      <Header3 />
      {!productId ? (
        <Typography variant="h5" gutterBottom color="error">
          Product ID is undefined
        </Typography>
      ) : (
        <>
          <Typography variant="h5" gutterBottom>
            Chat sobre el producto
          </Typography>
          <Box
            style={{
              height: "calc(90vh - 184px)",
              overflowY: "scroll",
              marginTop: "50px",
              paddingBottom: "150px",
              backgroundColor: "slateblue",
            }}
          >
            {messages.map((message) => (
              <div
                key={message.id}
                style={{
                  textAlign: message.senderId === authUserId ? "right" : "left",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    bgcolor: message.senderId === authUserId ? "#CAEDED" : "#FFF8E1",
                    m: 3,
                    p: 2,
                    borderRadius: "10px",
                    display: "inline-block",
                    color: "black",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: "bold",
                      textDecoration: "underline",
                      color:
                        message.senderId === authUserId
                          ? "dodgerblue"
                          : "mediumseagreen",
                    }}
                  >
                    {message.senderDisplayName}
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {message.content}
                  </Typography>
                </Typography>

                {message.senderId === authUserId && (
                  <Typography
                    sx={{
                      display: "block",
                      padding: "0px 20px 0px 20px",
                      color: "white",
                    }}
                    variant="caption"
                    color="textSecondary"
                  >
                    {message.read ? "Leído" : "Enviado"}
                  </Typography>
                )}
              </div>
            ))}
            <div ref={messagesEndRef} />
          </Box>
          <Box
            display="flex"
            alignItems="center"
            style={{
              width: "100%",
              position: "fixed",
              bottom: 56,
              background: "#fff",
              padding: "8px 0",
            }}
          >
            <TextField
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              placeholder="Escribe tu mensaje..."
              variant="outlined"
              fullWidth
              style={{
                width: "70%",
                margin: "auto",
                marginRight: "10px",
              }}
            />
            <Button
              style={{
                width: "20%",
                height: "56px",
                margin: "auto",
              }}
              variant="contained"
              color="primary"
              onClick={handleSendMessage}
            >
              Enviar
            </Button>
          </Box>
          <BottomNav />
        </>
      )}
    </Box>
  );
}

export default ChatBox;
